export default __webpack_public_path__ + "static/media/df.5cde3bdf.png";